import { FieldDesignChangeStatus } from '@cims-online/shared'
import { FieldDesignChange } from '../../../../../../FDCTrackerContext/types'
import CreateEditFormItems from '../../../../components/CreateEditFormItems'
import DisciplinesFormItem from '../../../../components/DisciplinesFormItem'
import IssueFormItem from '../../../../components/IssueFormItem'
import LocationFormItem from '../../../../components/LocationFormItem'
import ResolutionFormItem from '../../../../components/ResolutionFormItem'
import ExternalLinkEditor from 'components/ExternalLinkEditor'
import { useFDCTrackerContext } from '../../../../../../FDCTrackerContext'
import ConcurrenceLevelFormItem from '../../../../components/ConcurrenceLevelFormItem'
import CIMSFormItem from 'components/CIMSFormItem'
import { useDisabledOptions, DisabledOptions } from 'hooks/useDisabledOptions'

const EditModalBody: React.FC<FieldDesignChange> = ({
  fdcToFDCApprovalGroups,
  fdcToFDCConcurrenceGroups,
  statusId,
}) => {
  const {
    metadata,
    mutations: {
      edit: { canResolution, can },
    },
  } = useFDCTrackerContext()
  const isClosed = statusId === FieldDesignChangeStatus.Closed.id
  const isDraft = statusId === FieldDesignChangeStatus.Draft.id
  const isCloseOptions: DisabledOptions = {
    disabled: isClosed,
    reason: {
      why: 'invalid status',
      statusName: FieldDesignChangeStatus.Closed.name,
    },
  }
  const [commonDisabledOptions, { some: commonDisabled }] = useDisabledOptions([
    isCloseOptions,
    {
      disabled: !can,
      reason: 'missing permission',
    },
  ])
  const [resolutionDisabledOptions] = useDisabledOptions([
    isCloseOptions,
    {
      disabled: can ? false : !canResolution,
      reason: 'missing permission',
    },
    {
      disabled: fdcToFDCApprovalGroups.some(({ approved }) => approved),
      reason: {
        why: 'disabled',
        message:
          'Resolution cannot be edited once any Approval Groups have been approved',
      },
    },
  ])
  const [concurrenceDisabledOptions] = useDisabledOptions([
    ...(Array.isArray(commonDisabledOptions)
      ? commonDisabledOptions
      : [commonDisabledOptions]),
    {
      disabled: fdcToFDCConcurrenceGroups.some(({ concurred }) => concurred),
      reason: {
        why: 'disabled',
        message: `Cannot change Concurrence Level once a group has made a concurrence, 
          FDC must be rejected or reverted to change the Level`,
      },
    },
  ])

  return (
    <>
      <IssueFormItem disabled={commonDisabledOptions} />
      <ResolutionFormItem disabled={resolutionDisabledOptions} />
      <ConcurrenceLevelFormItem
        disabled={concurrenceDisabledOptions}
        filtered={isDraft}
        required={!isDraft}
      />
      <LocationFormItem disabled={commonDisabledOptions} required={!isDraft} />
      <DisciplinesFormItem
        disabled={commonDisabledOptions}
        required={!isDraft}
      />
      <CreateEditFormItems
        alreadyDisabled={
          isClosed
            ? {
                why: 'invalid status',
                statusName: FieldDesignChangeStatus.Closed.name,
              }
            : false
        }
        event="edit"
      />
      <CIMSFormItem disabled={commonDisabledOptions}>
        <ExternalLinkEditor
          quickLinkOptions={{
            loading: metadata?.loading,
            quickLinks: metadata?.fdcQuickLinks,
          }}
          messages={{ sharePoint: true }}
          disabled={commonDisabled}
        />
      </CIMSFormItem>
    </>
  )
}

export default EditModalBody
